package com.pincer.core.model.tree

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
data class Answer

(

    @JsName("wording") var wording : String,

)

{

    fun duplicate() = Answer(wording = wording)

}
